import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const OnboardingChatExampleStyles = styled(OnboardingPage)`
  ion-content {
    .img-container {
      width: 100%;
      max-width: 340px;
      margin: 20px auto 0;

      @media screen and (min-width: 576px) {
        max-width: 500px;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
`;
